import store from '@/store'

// 코인, 뱃지
export const mixinReward = {
  methods: {
    // 뱃지 획득
    async insertMemberBadgePoss(badgeNo, badgeDtlNo) {
      let params = {
        userKey: store.state.auth.authUser.userKey,
        badgeNo: badgeNo,
        badgeDtlNo: badgeDtlNo
      }
      await store.dispatch('insertMemberBadgePoss', this.$_payload('MemberBadgePo', params))
        .then(res => {
          if (res.success) {
            if (res.data.badgeNo !== null && res.data.badgeNo !== undefined) {
              store.commit('onBadgeModal', {
                badgeName: res.data.name,
                badgeImgPath: res.data.imgPath,
                badgeDialog: true
              })
            }
          }
        }).catch(() => {}).finally(() => {})
    },
    // 뱃지 삭제
    async deleteMemberBadgePoss(badgeNo, badgeDtlNo) {
      let params = [
        { userKey: store.state.auth.authUser.userKey },
        { badgeNo: badgeNo },
        { badgeDtlNo: badgeDtlNo }
      ]
      await store.dispatch('deleteMemberBadgePoss', this.$_payload('MemberBadgePo', params))
        .then(() => {}).catch(() => {}).finally(() => {})
    },
    // 코인 획득
    async insertMemberCoin(userKey, acquCoin, acquMethod, ordDtlNo) {
      // console.log(userKey, acquCoin, acquMethod, ordDtlNo)
      if (!this.isSamsungFire) { // 삼성화재는 코인 발급 x
        let params = {
          userKey: userKey,
          acquCoin: acquCoin,
          acquMethod: acquMethod,
          ordDtlNo: ordDtlNo
        }
        await store.dispatch('coinAdd', this.$_payload('CtCoinAcqu', params))
          .then(res => {
            if (res.success) {
              if (acquMethod !== '0005') {
                store.commit('onCoinModal', true)
              }
            }
          }).catch(() => {}).finally(() => {})
      }
    },
  }
}
